<template>
  <div class="comparador-page">
    <div class="comparador-box">
      <div class="comparador-header">
        <h1 class="comparador-title">Comparador</h1>
        <p class="comparador-subtitle">Compare dois personagens lado a lado (level, skills, previsão de preço)</p>
      </div>
      <div class="comparador-body">
        <div class="comparador-inputs">
          <div class="comparador-input-col">
            <label class="comparador-label">Personagem 1</label>
            <div class="comparador-input-wrap">
              <input
                v-model="name1"
                type="text"
                class="comparador-input"
                placeholder="Nome do personagem"
                :disabled="loading1"
                @keyup.enter="buscar1"
              />
              <button
                type="button"
                class="comparador-btn"
                :disabled="loading1 || !name1Trimmed"
                @click="buscar1"
              >
                {{ loading1 ? "Buscando..." : "Buscar" }}
              </button>
            </div>
            <p v-if="error1" class="comparador-error">{{ error1 }}</p>
          </div>
          <div class="comparador-input-col">
            <label class="comparador-label">Personagem 2</label>
            <div class="comparador-input-wrap">
              <input
                v-model="name2"
                type="text"
                class="comparador-input"
                placeholder="Nome do personagem"
                :disabled="loading2"
                @keyup.enter="buscar2"
              />
              <button
                type="button"
                class="comparador-btn"
                :disabled="loading2 || !name2Trimmed"
                @click="buscar2"
              >
                {{ loading2 ? "Buscando..." : "Buscar" }}
              </button>
            </div>
            <p v-if="error2" class="comparador-error">{{ error2 }}</p>
          </div>
        </div>

        <div class="comparador-panels">
          <div class="comparador-panel">
            <div v-if="loading1" class="comparador-loading">
              <div class="comparador-spinner"></div>
              <p>{{ loadingMessage1 }}</p>
            </div>
            <template v-else-if="result1">
              <div class="comparador-panel-header">
                <h2 class="comparador-char-name">{{ char1.name || "—" }}</h2>
                <span class="comparador-badge">{{ sourceLabel1 }}</span>
              </div>
              <div class="comparador-panel-body">
                <div class="comparador-stats">
                  <div v-if="char1.level != null" class="comparador-stat">
                    <span class="comparador-stat-label">Level</span>
                    <span class="comparador-stat-value">{{ char1.level }}</span>
                  </div>
                  <div v-if="char1.vocation" class="comparador-stat">
                    <span class="comparador-stat-label">Vocação</span>
                    <span class="comparador-stat-value">{{ char1.vocation }}</span>
                  </div>
                  <div v-if="char1.world" class="comparador-stat">
                    <span class="comparador-stat-label">World</span>
                    <span class="comparador-stat-value">{{ char1.world }}</span>
                  </div>
                </div>
                <div v-if="pricePrediction1 && pricePrediction1.sufficientData" class="comparador-prediction">
                  <h3 class="comparador-pred-title">Previsão de preço</h3>
                  <p class="comparador-pred-avg">
                    <img src="/img/rubinicoin.png" alt="" class="comparador-coin" />
                    {{ pricePrediction1.avgPrice != null ? pricePrediction1.avgPrice.toLocaleString("pt-BR") : "—" }} RC
                  </p>
                  <p class="comparador-pred-based">Baseado em {{ pricePrediction1.count }} vendas (Lvl {{ pricePrediction1.levelMin }}–{{ pricePrediction1.levelMax }})</p>
                </div>
                <div v-else-if="char1.world && char1.level != null && pricePrediction1 && !pricePrediction1.sufficientData" class="comparador-prediction">
                  <p class="comparador-pred-insufficient">Dados insuficientes para previsão</p>
                </div>
                <div v-if="auctions1.length" class="comparador-auctions">
                  <h3 class="comparador-section-title">Leilões</h3>
                  <div v-for="a in auctions1" :key="a.id" class="comparador-auction-row">
                    <span v-if="a.bidValue != null" class="comparador-price">
                      <img src="/img/rubinicoin.png" alt="" class="comparador-coin" />
                      {{ a.bidValue.toLocaleString("pt-BR") }} RC
                    </span>
                    <span class="comparador-auction-meta">{{ a.status }} · {{ a.outcome || "—" }}</span>
                  </div>
                  <p v-if="avgPrice1 != null" class="comparador-avg">Média: {{ avgPrice1.toLocaleString("pt-BR") }} RC</p>
                </div>
                <div v-if="skills1.length" class="comparador-skills">
                  <h3 class="comparador-section-title">Skills</h3>
                  <div class="comparador-skills-wrap">
                    <span v-for="s in skills1" :key="s.skillName" class="comparador-skill-badge">
                      {{ s.skillName }}: {{ s.level }}
                    </span>
                  </div>
                </div>
              </div>
            </template>
            <div v-else class="comparador-empty">Informe o nome e busque o personagem 1</div>
          </div>

          <div class="comparador-panel">
            <div v-if="loading2" class="comparador-loading">
              <div class="comparador-spinner"></div>
              <p>{{ loadingMessage2 }}</p>
            </div>
            <template v-else-if="result2">
              <div class="comparador-panel-header">
                <h2 class="comparador-char-name">{{ char2.name || "—" }}</h2>
                <span class="comparador-badge">{{ sourceLabel2 }}</span>
              </div>
              <div class="comparador-panel-body">
                <div class="comparador-stats">
                  <div v-if="char2.level != null" class="comparador-stat">
                    <span class="comparador-stat-label">Level</span>
                    <span class="comparador-stat-value">{{ char2.level }}</span>
                  </div>
                  <div v-if="char2.vocation" class="comparador-stat">
                    <span class="comparador-stat-label">Vocação</span>
                    <span class="comparador-stat-value">{{ char2.vocation }}</span>
                  </div>
                  <div v-if="char2.world" class="comparador-stat">
                    <span class="comparador-stat-label">World</span>
                    <span class="comparador-stat-value">{{ char2.world }}</span>
                  </div>
                </div>
                <div v-if="pricePrediction2 && pricePrediction2.sufficientData" class="comparador-prediction">
                  <h3 class="comparador-pred-title">Previsão de preço</h3>
                  <p class="comparador-pred-avg">
                    <img src="/img/rubinicoin.png" alt="" class="comparador-coin" />
                    {{ pricePrediction2.avgPrice != null ? pricePrediction2.avgPrice.toLocaleString("pt-BR") : "—" }} RC
                  </p>
                  <p class="comparador-pred-based">Baseado em {{ pricePrediction2.count }} vendas (Lvl {{ pricePrediction2.levelMin }}–{{ pricePrediction2.levelMax }})</p>
                </div>
                <div v-else-if="char2.world && char2.level != null && pricePrediction2 && !pricePrediction2.sufficientData" class="comparador-prediction">
                  <p class="comparador-pred-insufficient">Dados insuficientes para previsão</p>
                </div>
                <div v-if="auctions2.length" class="comparador-auctions">
                  <h3 class="comparador-section-title">Leilões</h3>
                  <div v-for="a in auctions2" :key="a.id" class="comparador-auction-row">
                    <span v-if="a.bidValue != null" class="comparador-price">
                      <img src="/img/rubinicoin.png" alt="" class="comparador-coin" />
                      {{ a.bidValue.toLocaleString("pt-BR") }} RC
                    </span>
                    <span class="comparador-auction-meta">{{ a.status }} · {{ a.outcome || "—" }}</span>
                  </div>
                  <p v-if="avgPrice2 != null" class="comparador-avg">Média: {{ avgPrice2.toLocaleString("pt-BR") }} RC</p>
                </div>
                <div v-if="skills2.length" class="comparador-skills">
                  <h3 class="comparador-section-title">Skills</h3>
                  <div class="comparador-skills-wrap">
                    <span v-for="s in skills2" :key="s.skillName" class="comparador-skill-badge">
                      {{ s.skillName }}: {{ s.level }}
                    </span>
                  </div>
                </div>
              </div>
            </template>
            <div v-else class="comparador-empty">Informe o nome e busque o personagem 2</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { characterLookup, getCharacterLookupStatus, getPricePrediction } from "@/api.js";

const POLL_INTERVAL_MS = 2500;
const POLL_MAX_ATTEMPTS = 60;
const KNOWN_SKILLS = [
  "Magic Level", "Fist Fighting", "Distance Fighting", "Sword Fighting",
  "Club Fighting", "Axe Fighting", "Shielding", "Fishing",
];

function charFromResult(result) {
  if (!result) return {};
  if (result.source === "auctions" && result.character) return result.character;
  if (result.source === "profile" && result.profile) return result.profile;
  if (result.source === "pending" && result.profile) return result.profile;
  return {};
}

function normalizeSkills(raw) {
  if (!raw || !Array.isArray(raw)) return [];
  const byName = new Map();
  for (const s of raw) {
    if (!s || typeof s !== "object") continue;
    const name = String(s.skillName || "").trim();
    const level = Number(s.level);
    if (!name || !KNOWN_SKILLS.includes(name) || Number.isNaN(level) || level < 0 || level > 200) continue;
    const cur = byName.get(name);
    if (cur == null || level > cur) byName.set(name, level);
  }
  return Array.from(byName.entries()).map(([skillName, level]) => ({ skillName, level }));
}

export default {
  data() {
    return {
      name1: "",
      name2: "",
      loading1: false,
      loading2: false,
      loadingMessage1: "Buscando...",
      loadingMessage2: "Buscando...",
      error1: null,
      error2: null,
      result1: null,
      result2: null,
      pricePrediction1: null,
      pricePrediction2: null,
    };
  },
  computed: {
    name1Trimmed() {
      return (this.name1 || "").trim();
    },
    name2Trimmed() {
      return (this.name2 || "").trim();
    },
    char1() {
      return charFromResult(this.result1);
    },
    char2() {
      return charFromResult(this.result2);
    },
    sourceLabel1() {
      if (!this.result1) return "";
      return this.result1.source === "auctions" ? "Na base (leilões)" : "Consulta no site";
    },
    sourceLabel2() {
      if (!this.result2) return "";
      return this.result2.source === "auctions" ? "Na base (leilões)" : "Consulta no site";
    },
    auctions1() {
      if (!this.result1 || this.result1.source !== "auctions" || !this.result1.auctions) return [];
      return this.result1.auctions;
    },
    auctions2() {
      if (!this.result2 || this.result2.source !== "auctions" || !this.result2.auctions) return [];
      return this.result2.auctions;
    },
    skills1() {
      return normalizeSkills(this.char1?.skills);
    },
    skills2() {
      return normalizeSkills(this.char2?.skills);
    },
    avgPrice1() {
      const finished = this.auctions1.filter((a) => a.outcome === "FINISHED" && a.bidValue != null);
      if (finished.length === 0) return null;
      return Math.round(finished.reduce((acc, a) => acc + a.bidValue, 0) / finished.length);
    },
    avgPrice2() {
      const finished = this.auctions2.filter((a) => a.outcome === "FINISHED" && a.bidValue != null);
      if (finished.length === 0) return null;
      return Math.round(finished.reduce((acc, a) => acc + a.bidValue, 0) / finished.length);
    },
  },
  watch: {
    result1(val) {
      this.pricePrediction1 = null;
      const c = charFromResult(val);
      if (c?.world && c?.level != null && c.level > 0) this.fetchPricePrediction(1);
    },
    result2(val) {
      this.pricePrediction2 = null;
      const c = charFromResult(val);
      if (c?.world && c?.level != null && c.level > 0) this.fetchPricePrediction(2);
    },
  },
  methods: {
    async buscar1() {
      await this.buscar(1);
    },
    async buscar2() {
      await this.buscar(2);
    },
    async buscar(side) {
      const name = side === 1 ? this.name1Trimmed : this.name2Trimmed;
      if (!name) return;
      if (side === 1) {
        this.loading1 = true;
        this.loadingMessage1 = "Buscando...";
        this.error1 = null;
        this.result1 = null;
      } else {
        this.loading2 = true;
        this.loadingMessage2 = "Buscando...";
        this.error2 = null;
        this.result2 = null;
      }
      try {
        const data = await characterLookup(name);
        if (data.error) {
          if (side === 1) this.error1 = data.error;
          else this.error2 = data.error;
          return;
        }
        if (data.source === "auctions" || data.source === "profile") {
          if (side === 1) this.result1 = data;
          else this.result2 = data;
          return;
        }
        if (data.source === "pending" && data.jobId) {
          if (side === 1) this.loadingMessage1 = "Buscando no site RubinOT...";
          else this.loadingMessage2 = "Buscando no site RubinOT...";
          await this.pollStatus(data.jobId, side);
          return;
        }
        if (side === 1) this.error1 = "Resposta inesperada";
        else this.error2 = "Resposta inesperada";
      } catch (err) {
        const msg = err.message || "Erro ao buscar";
        if (side === 1) this.error1 = msg;
        else this.error2 = msg;
      } finally {
        if (side === 1) this.loading1 = false;
        else this.loading2 = false;
      }
    },
    pollStatus(jobId, side) {
      return new Promise((resolve) => {
        let attempts = 0;
        const poll = async () => {
          attempts++;
          try {
            const status = await getCharacterLookupStatus(jobId);
            if (status.status === "done" && status.profile) {
              const result = { source: "profile", profile: status.profile };
              if (side === 1) this.result1 = result;
              else this.result2 = result;
              resolve();
              return;
            }
            if (status.status === "failed") {
              const msg = status.error || "Falha ao buscar personagem";
              if (side === 1) this.error1 = msg;
              else this.error2 = msg;
              resolve();
              return;
            }
            if (attempts < POLL_MAX_ATTEMPTS) setTimeout(poll, POLL_INTERVAL_MS);
            else {
              if (side === 1) this.error1 = "Tempo esgotado. Tente novamente.";
              else this.error2 = "Tempo esgotado. Tente novamente.";
              resolve();
            }
          } catch (_) {
            if (attempts < POLL_MAX_ATTEMPTS) setTimeout(poll, POLL_INTERVAL_MS);
            else {
              if (side === 1) this.error1 = "Erro ao verificar status";
              else this.error2 = "Erro ao verificar status";
              resolve();
            }
          }
        };
        poll();
      });
    },
    async fetchPricePrediction(side) {
      const c = side === 1 ? this.char1 : this.char2;
      if (!c?.world || c?.level == null) return;
      try {
        const params = { world: c.world, level: c.level };
        if (c.vocation) params.vocation = c.vocation;
        const data = await getPricePrediction(params);
        if (side === 1) this.pricePrediction1 = data;
        else this.pricePrediction2 = data;
      } catch (_) {
        if (side === 1) this.pricePrediction1 = { sufficientData: false, count: 0 };
        else this.pricePrediction2 = { sufficientData: false, count: 0 };
      }
    },
  },
};
</script>
<style scoped>
.comparador-page {
  min-height: 60vh;
}

.comparador-box {
  border: 2px solid #8b6914;
  border-radius: 8px;
  background: linear-gradient(180deg, #2a2520 0%, #1c1916 100%);
  overflow: hidden;
}

.comparador-header {
  background: rgba(139, 105, 20, 0.25);
  border-bottom: 1px solid rgba(139, 105, 20, 0.5);
  padding: 1.25rem 1.5rem;
}

.comparador-title {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 700;
  color: #d4af37;
  letter-spacing: 0.02em;
}

.comparador-subtitle {
  margin: 0.35rem 0 0;
  font-size: 0.9rem;
  color: #8a7a5c;
}

.comparador-body {
  padding: 1.5rem;
}

.comparador-inputs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  margin-bottom: 1.5rem;
}

@media (max-width: 767px) {
  .comparador-inputs {
    grid-template-columns: 1fr;
  }
}

.comparador-input-col {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.comparador-label {
  font-size: 0.9rem;
  font-weight: 600;
  color: #8b6914;
}

.comparador-input-wrap {
  display: flex;
  gap: 0.5rem;
}

.comparador-input {
  flex: 1;
  padding: 0.6rem 0.9rem;
  font-size: 1rem;
  color: #e8dcc8;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(139, 105, 20, 0.5);
  border-radius: 6px;
}

.comparador-input::placeholder {
  color: #6a5c4a;
}

.comparador-input:focus {
  outline: none;
  border-color: #8b6914;
}

.comparador-btn {
  padding: 0.6rem 1rem;
  font-size: 1rem;
  font-weight: 600;
  color: #1c1916;
  background: linear-gradient(180deg, #d4af37 0%, #b8960c 100%);
  border: 1px solid #8b6914;
  border-radius: 6px;
  cursor: pointer;
  white-space: nowrap;
}

.comparador-btn:hover:not(:disabled) {
  background: linear-gradient(180deg, #e0bc45 0%, #c9a510 100%);
}

.comparador-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.comparador-error {
  margin: 0;
  font-size: 0.9rem;
  color: #c75c5c;
}

.comparador-panels {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
}

@media (max-width: 991px) {
  .comparador-panels {
    grid-template-columns: 1fr;
  }
}

.comparador-panel {
  min-height: 280px;
  border: 1px solid rgba(139, 105, 20, 0.5);
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.25);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.comparador-loading {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  color: #8a7a5c;
}

.comparador-spinner {
  width: 36px;
  height: 36px;
  border: 3px solid rgba(139, 105, 20, 0.3);
  border-top-color: #d4af37;
  border-radius: 50%;
  animation: comparador-spin 0.9s linear infinite;
}

@keyframes comparador-spin {
  to {
    transform: rotate(360deg);
  }
}

.comparador-empty {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  color: #8a7a5c;
  font-size: 0.95rem;
}

.comparador-panel-header {
  padding: 1rem 1.25rem;
  border-bottom: 1px solid rgba(139, 105, 20, 0.35);
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.comparador-char-name {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 700;
  color: #d4af37;
}

.comparador-badge {
  padding: 0.2rem 0.5rem;
  font-size: 0.7rem;
  color: #1c1916;
  background: rgba(212, 175, 55, 0.4);
  border: 1px solid rgba(139, 105, 20, 0.5);
  border-radius: 4px;
}

.comparador-panel-body {
  padding: 1rem 1.25rem;
  color: #e8dcc8;
  font-size: 0.9rem;
}

.comparador-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem 1.5rem;
  margin-bottom: 1rem;
}

.comparador-stat {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.comparador-stat-label {
  font-size: 0.75rem;
  color: #8a7a5c;
}

.comparador-stat-value {
  font-weight: 600;
  color: #c9b896;
}

.comparador-prediction {
  margin-bottom: 1rem;
  padding: 0.75rem;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 6px;
  border: 1px solid rgba(139, 105, 20, 0.35);
}

.comparador-pred-title {
  margin: 0 0 0.35rem;
  font-size: 0.85rem;
  font-weight: 600;
  color: #8b6914;
}

.comparador-pred-avg {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #d4af37;
  display: flex;
  align-items: center;
  gap: 0.35rem;
}

.comparador-pred-based,
.comparador-pred-insufficient {
  margin: 0.35rem 0 0;
  font-size: 0.8rem;
  color: #8a7a5c;
}

.comparador-coin {
  max-height: 1rem;
  width: auto;
  vertical-align: middle;
}

.comparador-section-title {
  margin: 0 0 0.5rem;
  font-size: 0.85rem;
  font-weight: 600;
  color: #8b6914;
}

.comparador-auctions {
  margin-bottom: 1rem;
}

.comparador-auction-row {
  display: block;
  padding: 0.4rem 0;
  border-bottom: 1px solid rgba(139, 105, 20, 0.2);
}

.comparador-price {
  color: #d4af37;
  font-weight: 600;
}

.comparador-auction-meta {
  font-size: 0.8rem;
  color: #8a7a5c;
  margin-left: 0.5rem;
}

.comparador-avg {
  margin: 0.5rem 0 0;
  font-size: 0.9rem;
  color: #d4af37;
}

.comparador-skills-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
}

.comparador-skill-badge {
  padding: 0.25rem 0.5rem;
  font-size: 0.8rem;
  color: #e8dcc8;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(139, 105, 20, 0.4);
  border-radius: 6px;
}
</style>
